import { createSlice } from '@reduxjs/toolkit';
import { FILTER_VALUES } from '../../constants/FilterConstants';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';
import { AREA_TAX_LOCATION_NAME_ASC } from '../../constants/SortConstants';

const defaultFilterState = {
  [FILTER_VALUES.SUBLOCATION_ID]: [],
  searchText: '',
  pageNumber: DEFAULT_PAGE,
  rowsPerPage: DEFAULT_PER_PAGE,
  sort: AREA_TAX_LOCATION_NAME_ASC,
};

const initialState = {
  activeAreaTaxLocations: { ...defaultFilterState },
  archivedAreaTaxLocations: { ...defaultFilterState },
};

export const manageAreaTaxLocationFiltersSlice = createSlice({
  name: 'manageAreaTaxLocationFilters',
  initialState,
  reducers: {
    setActiveAreaTaxLocationFilters(state, action) {
      if (!state.activeAreaTaxLocations) state.activeAreaTaxLocations = { ...defaultFilterState };
      state.activeAreaTaxLocations[FILTER_VALUES.SUBLOCATION_ID] = action.payload?.sublocationId || [];
      state.activeAreaTaxLocations.searchText = action.payload?.searchText ?? '';
      state.activeAreaTaxLocations.pageNumber = action.payload?.pageNumber || DEFAULT_PAGE;
      state.activeAreaTaxLocations.rowsPerPage = action.payload?.rowsPerPage || DEFAULT_PER_PAGE;
      state.activeAreaTaxLocations.sort = action.payload?.sort || AREA_TAX_LOCATION_NAME_ASC;
    },
    setArchivedAreaTaxLocationFilters(state, action) {
      if (!state.archivedAreaTaxLocations) state.archivedAreaTaxLocations = { ...defaultFilterState };
      state.archivedAreaTaxLocations[FILTER_VALUES.SUBLOCATION_ID] = action.payload?.sublocationId || [];
      state.archivedAreaTaxLocations.searchText = action.payload?.searchText ?? '';
      state.archivedAreaTaxLocations.pageNumber = action.payload?.pageNumber || DEFAULT_PAGE;
      state.archivedAreaTaxLocations.rowsPerPage = action.payload?.rowsPerPage || DEFAULT_PER_PAGE;
      state.archivedAreaTaxLocations.sort = action.payload?.sort || AREA_TAX_LOCATION_NAME_ASC;
    },
    resetActiveAreaTaxLocationFiltersState(state) {
      state.activeAreaTaxLocations = {
        ...defaultFilterState,
        searchText: state.activeAreaTaxLocations?.searchText ?? '',
        sort: state.activeAreaTaxLocations?.sort || AREA_TAX_LOCATION_NAME_ASC,
      };
    },
    resetArchivedAreaTaxLocationFiltersState(state) {
      state.archivedAreaTaxLocations = {
        ...defaultFilterState,
        searchText: state.archivedAreaTaxLocations?.searchText ?? '',
        sort: state.archivedAreaTaxLocations?.sort || AREA_TAX_LOCATION_NAME_ASC,
      };
    },
    resetState(state) {
      Object.assign(state, initialState);
    },
  },
});

export default manageAreaTaxLocationFiltersSlice;
